module.exports = __webpack_public_path__ + "img/DC-Logo-Web-Black-StackedTagline.b17a017.png";